module.exports = __webpack_public_path__ + "img/union.70ff681f.png";